const baseUrl = '/stock/product-categories';

export const getAddProductCategoryLink = () => `${baseUrl}/new`;
export const getAddProductCategoryProductLink = (id: number) => `${getProductCategoryLink(id)}/products/new`;
export const getProductCategoriesLink = () => baseUrl;
export const getProductCategoryLink = (id: number) => `${baseUrl}/${id}`;
export const getEditProductCategoryLink = (id: number) => `${baseUrl}/${id}/edit`;
export const getEditProductCategoryProductLink = (productCategoryId: number, productId: number) =>
  `${getProductCategoryLink(productCategoryId)}/products/${productId}/edit`;
